import './preloaderLine.css'

const PreloaderLine = ()=>{
    return <div className="preloader_track">
        <div className="progress">
        </div>
    </div>
}

export default PreloaderLine;